import { useCallback, useRef, useState } from "react";
import { Platform } from "react-native";
import * as Linking from "expo-linking";

const APP_STORE_LINK = process.env.EXPO_PUBLIC_APP_STORE_LINK!;
const PLAY_STORE_LINK = process.env.EXPO_PUBLIC_PLAY_STORE_LINK!;
const APP_SCHEME = process.env.EXPO_PUBLIC_APP_SCHEME!;

const getMobileOS = () => {
  if (Platform.OS !== "web") {
    return Platform.OS;
  }

  const userAgent =
    navigator.userAgent || navigator.vendor || (window as any).opera;

  if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
    return "ios";
  }

  if (/android/i.test(userAgent)) {
    return "android";
  }

  return "web";
};

function getLink() {
  switch (getMobileOS()) {
    case "ios":
      return APP_STORE_LINK;
    case "android":
      return PLAY_STORE_LINK;
    default:
      return PLAY_STORE_LINK;
  }
}

export function useRedirectToStore() {
  return useCallback(() => {
    const storeUrl = getLink();

    Linking.openURL(storeUrl);
    return storeUrl;
  }, []);
}

function buildCustomUrl(scheme: string, path: string): string {
  const cleanedScheme = scheme.endsWith("//") ? scheme : `${scheme}//`;
  const cleanedPath = path.replace(/^\/*/, "");
  return `${cleanedScheme}${cleanedPath}`;
}

export function useWebToAppRedirect() {
  const frame = useRef<HTMLElement | null>(null);
  const timeoutHandle = useRef<any>(null);
  const [appPending, setAppPending] = useState<boolean>(false);
  const redirectToStore = useRedirectToStore();

  const removeFrameIfNeeded = useCallback(() => {
    if (frame.current?.parentNode) {
      frame.current.parentNode.removeChild(frame.current);
    }
    frame.current = null;
  }, []);

  const clearAppPending = useCallback(() => {
    clearInterval(timeoutHandle.current);
    timeoutHandle.current = null;
    setAppPending(false);
    removeFrameIfNeeded();
  }, [removeFrameIfNeeded]);

  const openApp = useCallback(
    (url: string, fallbackToStore: boolean) => {
      if (timeoutHandle.current) {
        return;
      }

      const appUrl = buildCustomUrl(APP_SCHEME, url);
      const isIOS = getMobileOS() === "ios";

      if (isIOS) {
        try {
          window.location.href = appUrl;
        } catch (_) {}

        const interval = setInterval(() => {
          if (fallbackToStore) {
            if (document.hasFocus()) {
              clearAppPending();
              redirectToStore();
            }
          } else {
            clearAppPending();
          }
        }, 2000);

        timeoutHandle.current = interval;
        setAppPending(true);
      } else {
        // Оригинальная реализация для Android/других платформ
        const hiddenIframe = document.createElement("iframe");
        hiddenIframe.style.display = "none";
        hiddenIframe.src = appUrl;
        frame.current = hiddenIframe;
        document.body.appendChild(hiddenIframe);

        const interval = setInterval(() => {
          removeFrameIfNeeded();
          if (fallbackToStore) {
            if (document.hasFocus()) {
              clearAppPending();
              redirectToStore();
            }
          } else {
            clearAppPending();
          }
        }, 2000);

        timeoutHandle.current = interval;
        setAppPending(true);
      }
    },
    [setAppPending, clearAppPending, removeFrameIfNeeded, redirectToStore]
  );

  return { openApp, appPending };
}

// export function useWebToAppRedirect() {
//   const frame = useRef<HTMLElement | null>();
//   const timeoutHandle = useRef<any>();
//   const [appPending, setAppPending] = useState<boolean>(false);
//   const redirectToStore = useRedirectToStore();

//   const removeFrameIfNeeded = useCallback(() => {
//     if (frame.current?.parentNode) {
//       frame.current.parentNode.removeChild(frame.current);
//     }

//     frame.current = null;
//   }, []);

//   const clearAppPending = useCallback(() => {
//     clearInterval(timeoutHandle.current);
//     timeoutHandle.current = null;
//     setAppPending(false);

//     removeFrameIfNeeded();
//   }, []);

//   const openApp = useCallback(
//     (url: string, fallbackToStore: boolean) => {
//       if (timeoutHandle.current) {
//         return;
//       }

//       const appUrl = buildCustomUrl(APP_SCHEME, url);

//       const hiddenIframe = document.createElement("iframe");
//       hiddenIframe.style.display = "none";
//       hiddenIframe.src = appUrl;
//       frame.current = hiddenIframe;
//       document.body.appendChild(hiddenIframe);

//       const interval = setInterval(() => {
//         removeFrameIfNeeded();

//         if (fallbackToStore) {
//           if (document.hasFocus()) {
//             clearAppPending();
//             redirectToStore();
//           }
//         } else {
//           clearAppPending();
//         }
//       }, 2000);

//       timeoutHandle.current = interval;
//       setAppPending(true);
//     },
//     [setAppPending]
//   );

//   return {
//     openApp,
//     appPending,
//     redirectToStore,
//   };
// }
